import { DEV, EVAL, FLUENTSMS, PROD, resolveDomain, resolveEnv, TITLESOLUTIONS } from '@fluentsms/utils';

import { getUriOverride, getWssOverride } from './devEndpointOverride';

const config: {
  [domain: string]: {
    [env: string]: {
      uri: string;
      uriwss: string;
    };
  };
} = {
  [FLUENTSMS]: {
    [DEV]: {
      uri: 'https://dev.fluentapi.titlesolutions.com/graphql', // modify for feature branch testing, revert before merge
      uriwss: 'wss://dev.fluentwebsockets.titlesolutions.com/subscriptions',
    },
    [EVAL]: {
      uri: 'https://eval.fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://eval.fluentwebsockets.titlesolutions.com/subscriptions',
    },
    [PROD]: {
      uri: 'https://fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://fluentwebsockets.titlesolutions.com/subscriptions',
    },
  },
  [TITLESOLUTIONS]: {
    [DEV]: {
      uri: 'https://dev.fluentapi.titlesolutions.com/graphql', // modify for feature branch testing, revert before merge
      uriwss: 'wss://dev.fluentwebsockets.titlesolutions.com/subscriptions',
    },
    [EVAL]: {
      uri: 'https://eval.fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://eval.fluentwebsockets.titlesolutions.com/subscriptions',
    },
    [PROD]: {
      uri: 'https://fluentapi.titlesolutions.com/graphql',
      uriwss: 'wss://fluentwebsockets.titlesolutions.com/subscriptions',
    },
  },
};

const baseConfig = config[resolveDomain()][resolveEnv()];

const dynamicConfig: { uri: string; uriwss: string } = Object.defineProperties({} as { uri: string; uriwss: string }, {
  uri: {
    get: () => getUriOverride() ?? baseConfig.uri,
    enumerable: true,
  },
  uriwss: {
    get: () => getWssOverride() ?? baseConfig.uriwss,
    enumerable: true,
  },
});

export default dynamicConfig;
